export default __webpack_public_path__ + "static/media/miguel-lopes-23.f97f59fc.jpg";